import { ScheduleTestID, TextTestID } from "@/constants/TestID";
import { IllustrationSize } from "@/constants/UI";
import { Button, FAIconName } from "@/ui/core";
import { VStack } from "@/ui/layout";
import EmptyListContent from "@/ui/layout/list/EmptyListContent";
import {
  getIllustrationIcon,
  IllustrationName,
} from "@/ui/theme/icons/illustrations/groupClasses";
import { joinTestIDs } from "@/utils/string.util";

interface SectionEmptyListCardProps {
  buttonTitle?: string;
  description: string;
  iconName?: IllustrationName;
  onButtonPress: () => void;
  title: string;
}

/* eslint complexity: ["error", {max:15}] -- this overrides for the entire file */
const SectionEmptyListCard = ({
  buttonTitle,
  description,
  iconName = IllustrationName.Exclamation,
  onButtonPress,
  title,
}: SectionEmptyListCardProps) => {
  const IllustrationIcon = getIllustrationIcon({
    height: IllustrationSize.UpcomingEvents,
    iconName,
    width: IllustrationSize.UpcomingEvents,
  });
  return (
    <VStack alignItems="flex-start" gap={10}>
      {IllustrationIcon}
      <EmptyListContent
        paragraphs={[description]}
        testID={ScheduleTestID.EmptyList}
        title={title}
      />
      {buttonTitle && (
        <Button
          onPress={onButtonPress}
          rightIcon={FAIconName.ChevronRight}
          testID={joinTestIDs(ScheduleTestID.EmptyList, TextTestID.Text)}
          title={buttonTitle}
          variant="tertiary"
        />
      )}
    </VStack>
  );
};

export type { SectionEmptyListCardProps };
export default SectionEmptyListCard;
